export enum Countries {
  USA = 1,
}

export enum AddressTypes {
  PERMANENT = 1,
}

export class CountryIds {
  public static get USA(): number {
    return Countries.USA;
  }
}

export class AddressTypeIds {
  public static get PERMANENT(): number {
    return AddressTypes.PERMANENT;
  }
}
